module.exports = __webpack_public_path__ + "media/images/press_kit/azamara/email/top-light-65166f518ff5e5c42e3e3e3448cc6521.png";